import { render } from "./Bottom.vue?vue&type=template&id=23c16371&scoped=true&ts=true"
import script from "./Bottom.vue?vue&type=script&lang=ts"
export * from "./Bottom.vue?vue&type=script&lang=ts"

import "./Bottom.vue?vue&type=style&index=0&id=23c16371&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c16371"]])

export default __exports__